export default __webpack_public_path__ + "img/1_13-798bf134.png";